import { Role } from '@app/main/api';

export const EMPLOYEE_DEFAULT_PROVIDER_JOB = 'Title';
export const EMPLOYEE_DEFAULT_APPOINTMENT_DURATION_MINUTES = 15;

interface PerformerDefaultsFields {
  roles?: Role[];
  providerInfo?: ({ job?: string | null } & Record<string, unknown>) | null;
  appointmentHostPreferences?:
    | ({ defaultAppointmentDurationMinutes?: number | null } & Record<string, unknown>)
    | null;
}

type WithEmployeeProviderDefaults<T extends PerformerDefaultsFields> = Omit<
  T,
  'providerInfo' | 'appointmentHostPreferences'
> & {
  providerInfo: NonNullable<T['providerInfo']> & {
    job: string;
  };
  appointmentHostPreferences: NonNullable<T['appointmentHostPreferences']> & {
    defaultAppointmentDurationMinutes: number;
  };
};

export function withEmployeeProviderDefaults<T extends PerformerDefaultsFields>(
  value: T,
): WithEmployeeProviderDefaults<T> {
  const fields = value as PerformerDefaultsFields;

  if (fields.roles && !fields.roles.includes(Role.PERFORMER)) {
    return value as WithEmployeeProviderDefaults<T>;
  }

  return {
    ...value,
    providerInfo: {
      ...(fields.providerInfo ?? {}),
      job: fields.providerInfo?.job ?? EMPLOYEE_DEFAULT_PROVIDER_JOB,
    },
    appointmentHostPreferences: {
      ...(fields.appointmentHostPreferences ?? {}),
      defaultAppointmentDurationMinutes:
        fields.appointmentHostPreferences?.defaultAppointmentDurationMinutes ??
        EMPLOYEE_DEFAULT_APPOINTMENT_DURATION_MINUTES,
    },
  } as WithEmployeeProviderDefaults<T>;
}
